import MembershipDocumentListPagingResultModelBase from '../_generated/modelBases/membership-document-list-paging-result-model-base';

export default class MembershipDocumentListPagingResultModel extends MembershipDocumentListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
